import { TipoAvaliacao } from '../../types/tipo-avaliacao.types';
import {
  AvaliacaoOrigin,
  CalendarioAvaliacao,
  FixtureCalendarioAvaliacao,
  TemaCalendarioAvaliacao,
} from './calendario-avaliacao.types';

const mockTemaCalendarioAvaliacao: TemaCalendarioAvaliacao = {
  codigo: 'ARA0297-1',
  nome: 'FUNDAMENTOS DO DIREITO',
  ordemApresentacao: 1,
};

const mock: CalendarioAvaliacao = {
  id: '1',
  marca: 'estacio',
  codigoDisciplina: 'ARA0003',
  temas: [mockTemaCalendarioAvaliacao],
  tipoAvaliacao: TipoAvaliacao.EXERCICIOS,
  origin: AvaliacaoOrigin.JUCA,
  tituloAvaliacao: 'tituloAvaliacao',
  disponibilidadeAvaliacaoInicio: new Date('2021-08-05T00:00:00.000Z'),
  disponibilidadeAvaliacaoFim: new Date('2021-08-05T00:00:00.000Z'),
  tempoDuracaoMinutos: 10,
  codigoPeriodo: '2021.3',
  quantidadeQuestoes: 5,
  quantidadeAcertos: 4,
  execucaoAvaliacaoInicio: new Date('2021-08-05T00:00:00.000Z'),
  execucaoAvaliacaoFim: new Date('2021-08-05T00:00:00.000Z'),
  avaliacaoAplicadaId: '1',
};

export const calendarioAvaliacaoFixture: FixtureCalendarioAvaliacao = () => {
  return {
    create: () => {
      const calendarioAvaliacao: CalendarioAvaliacao = { ...mock };

      return {
        id: function (param: string) {
          calendarioAvaliacao.id = param;
          return this;
        },
        marca: function (param: string) {
          calendarioAvaliacao.marca = param;
          return this;
        },
        codigoDisciplina: function (param: string) {
          calendarioAvaliacao.codigoDisciplina = param;
          return this;
        },
        temas: function (param: TemaCalendarioAvaliacao[]) {
          calendarioAvaliacao.temas = param;
          return this;
        },
        tipoAvaliacao: function (param: TipoAvaliacao) {
          calendarioAvaliacao.tipoAvaliacao = param;
          return this;
        },
        origin: function (param: AvaliacaoOrigin) {
          calendarioAvaliacao.origin = param;
          return this;
        },
        tituloAvaliacao: function (param: string) {
          calendarioAvaliacao.tituloAvaliacao = param;
          return this;
        },
        disponibilidadeAvaliacaoInicio: function (param: Date | undefined) {
          calendarioAvaliacao.disponibilidadeAvaliacaoInicio = param;
          return this;
        },
        disponibilidadeAvaliacaoFim: function (param: Date | undefined) {
          calendarioAvaliacao.disponibilidadeAvaliacaoFim = param;
          return this;
        },
        tempoDuracaoMinutos: function (param: number | undefined) {
          calendarioAvaliacao.tempoDuracaoMinutos = param;
          return this;
        },
        codigoPeriodo: function (param: string) {
          calendarioAvaliacao.codigoPeriodo = param;
          return this;
        },
        quantidadeQuestoes: function (param: number | undefined) {
          calendarioAvaliacao.quantidadeQuestoes = param;
          return this;
        },
        quantidadeAcertos: function (param: number | undefined) {
          calendarioAvaliacao.quantidadeAcertos = param;
          return this;
        },
        execucaoAvaliacaoInicio: function (param: Date | undefined) {
          calendarioAvaliacao.execucaoAvaliacaoInicio = param;
          return this;
        },
        execucaoAvaliacaoFim: function (param: Date | undefined) {
          calendarioAvaliacao.execucaoAvaliacaoFim = param;
          return this;
        },
        avaliacaoAplicadaId: function (param: string) {
          calendarioAvaliacao.avaliacaoAplicadaId = param;
          return this;
        },
        get: function () {
          return calendarioAvaliacao;
        },
      };
    },
  };
};
